module.exports = __webpack_public_path__ + "img/hide-map.ca94e579.svg";